import { useIntl } from 'react-intl';
import styles from './ComingSoon.module.css';

const ComingSoon = ({ titleId }) => {
	const intl = useIntl();

	return (
		<div className={styles.container}>
			<h1 className={styles.title}>{intl.formatMessage({ id: titleId })}</h1>
			<p className={styles.text}>
				{intl.formatMessage({ id: 'ComingSoonId1' })}
			</p>
		</div>
	);
};

export default ComingSoon;
